import MobileOptionCard, { MOBILE_CARD_PIXEL_HEIGHT } from './MobileOptionCard';
export { MOBILE_CARD_PIXEL_HEIGHT };
export default MobileOptionCard;
